import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=f2457e20&scoped=true"
import script from "./Campaigns.vue?vue&type=script&setup=true&lang=ts"
export * from "./Campaigns.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=f2457e20&prod&scoped=true&lang=css"
import style1 from "./Campaigns.vue?vue&type=style&index=1&id=f2457e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2457e20",
  null
  
)

export default component.exports